<template>
  <button
    :type="type"
    role="button"
    :class="['button', { 'button--loading': this.clicked }]"
    :disabled="disabled"
  >
    <font-awesome-icon class="button-icon" v-if="icon" :icon="`${icon}`" />
    <span><slot></slot></span>
    <font-awesome-icon
      class="button-icon control-icon__loading control-icon--right"
      icon="spinner"
      spin
    />
  </button>
</template>

<script>
export default {
  data() {
    return {
      clicked: false
    };
  },
  mounted() {
    this.$root.$on('button-loading', res => {
      this.clicked = res;
    });
  },
  name: 'Button',
  props: ['type', 'icon', 'disabled']
};
</script>

<style lang="scss">
.button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  padding: 16px 32px;
  background-color: var(--color-balanced);
  font-size: 12px;
  font-weight: 600;
  color: var(--color-white);
  transition: var(--transition);
  text-transform: uppercase;

  @media (min-width: 768px) {
    font-size: 14px;
  }

  &:not(.button--option) {
    &:hover {
      box-shadow: 0 8px 24px rgba(var(--color-balanced-rgb), 0.4);
    }

    &:focus {
      box-shadow: 0 0 0 3px rgba(var(--color-balanced-rgb), 0.2);
    }
  }

  .control-icon__loading {
    overflow: hidden !important;
    opacity: 0;
    font-size: 0;
    transition: 0.2s all ease;
  }

  &--loading,
  &[disabled] {
    pointer-events: none;
    opacity: 0.5;
  }

  &--loading {
    .control-icon__loading {
      opacity: 1;
      color: var(--color-white);
      margin-left: 16px;
      font-size: 16px;
    }
  }

  &--option {
    background-color: transparent;
    color: var(--color-balanced);
    border: 2px solid var(--color-balanced);
  }

  &--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    background-color: transparent;
    color: var(--color-balanced);
    border: 0;

    span {
      display: none;
    }

    &:hover,
    &:focus {
      box-shadow: none;
      border: 0;
    }
  }
}
</style>
